import React from 'react';
import PropTypes from 'prop-types';
import './sidebar.scss';

const SidebarSecondary = ({ children, size = 'md' }) => {
  return (
    <div className={`sidebar-secondary-container sidebar-secondary-${size}`}>
      <div className="sidebar-secondary bg-white">{children}</div>
    </div>
  );
};

SidebarSecondary.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default SidebarSecondary;
